const stages = {};

function validate(stage, samples, batchSize, cartridge) {
  const filledInMap = [];
  for (let i = 0; i < 96; i++) {
    filledInMap.push(null);
  }
  for (const sample of samples) {
    filledInMap[sample.well] = sample;
  }
  let broken = [];
  if (cartridge && cartridge.capillaries){
    for (let i = 0; i < cartridge.capillaries.length; i++) {
      if (cartridge.capillaries[i] !== 'good') {
        broken.push(i);
      }
    }
  }
  return validateInjections(filledInMap, batchSize, broken);
}

// brokenCapillaries = [1, 5] 0 indexed for each injection
function validateInjections(filledInMap, injectionSize, brokenCapillaries) {
  const result = {};
  function addError(well, error) {
    if (result[well]) {
      result[well] += '\n' + error;
    } else {
      result[well] = error;
    }
  }
  const errors = {
    missingPrimer: 'Missing Primer',
    broken: 'Broken Capillary',
    mismatch: 'Sanger and Fragment in same injection',
    missingSample: 'Missing sample/control',
  };

  for (let i = 0; i < 96; i += injectionSize) {
    let missingSamples = [];
    let hasSanger = false;
    let hasFragment = false;
    let hasSample = false;

    for (let j = 0; j < injectionSize; j++) {
      const well = i + j;
      if (filledInMap[well]) {
        hasSample = true;
        if (filledInMap[well].type === 'sanger') {
          hasSanger = true;
          // not premixed and missing primer
          if (filledInMap[well] !== 'premixed' && !filledInMap[well].primer) {
            addError(well, errors.missingPrimer);
          }
        }

        // brokenCapillaries is relative to the group start
        if (brokenCapillaries.includes(j) && filledInMap[well]) {
          addError(well, errors.broken);
        }
      } else {
        missingSamples.push(well);
      }
    }

    if (hasSample) {
      for (const missingSample of missingSamples) {
        addError(missingSample, errors.missingSample);
      }
    }

    if (hasSanger && hasFragment) {
      for (let j = 0; j < injectionSize; j++) {
        const well = i + j;
        addError(well, errors.mismatch);
      }
    }
  }
  return result;
}

export default validate;
